import React from "react";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import "./WithdrawTaxNotice.less";

export interface WithdrawTaxNoticeProps {
  rate?: number | string;
  amount?: number | string;
  className?: string;
}

const formatRate = (rate?: number | string) => {
  const text = `${rate ?? 0}`.trim();

  if (!text) {
    return "0%";
  }

  return text.endsWith("%") ? text : `${text}%`;
};

const formatAmount = (amount?: number | string) => {
  const text = `${amount ?? 0}`.trim();
  return text || "0";
};

const WithdrawTaxNotice = (props: WithdrawTaxNoticeProps) => {
  const { rate, amount, className } = props;
  const { t } = useTranslationPlus();
  const rateText = formatRate(rate);
  const amountText = formatAmount(amount);
  const notice = t("Wallet.WithdrawTaxNotice", {
    rate: rateText,
    amount: amountText,
  });
  const rateIndex = notice.indexOf(rateText);
  const prefix = rateIndex >= 0 ? notice.slice(0, rateIndex) : "";
  const suffix = rateIndex >= 0 ? notice.slice(rateIndex + rateText.length) : "";
  const rootClassName = ["withdraw-tax-notice", className]
    .filter(Boolean)
    .join(" ");

  if (rateIndex < 0) {
    return <div className={rootClassName}>{notice}</div>;
  }

  return (
    <div className={rootClassName}>
      {prefix}
      <span className="withdraw-tax-notice-rate">{rateText}</span>
      {suffix}
    </div>
  );
};

export default WithdrawTaxNotice;
